<script setup lang="ts">

import { useUser } from "@domain/Security";
import type { IMyGarageViewModel } from "../..";

const model = defineModel<IMyGarageViewModel>( { required: true } );

const user = useUser();
const overdueOrCritical = model.value.vehicle.condition.conditionsOverdueOrCritical.length;
const due = model.value.vehicle.condition.conditionsDue.length;
const hasAlerts = due + overdueOrCritical > 0;

</script>

<template>

    <!-- ALERTS -->
    <a v-if="hasAlerts"
       :href="'#'+ ( overdueOrCritical ? 'critical' : 'due' )"
       class="text-sm 3xl:text-base uppercase w-full flex justify-center py-3 lg:py-4 opacity-75"
       :class="{
             'bg-amber-500 text-black/90': due > 0,
             '!bg-rose-500/20 !text-rose-300': overdueOrCritical > 0,
             '-mt-10 !pt-14': user.isDealerMode
       }">
       <div v-if="overdueOrCritical > 0">
           {{ overdueOrCritical }} critical or overdue maintenance task{{ overdueOrCritical == 1 ? '' : 's' }}
       </div>
       <div v-else-if="due > 0" class="font-bold">
           {{ due }} maintenance task{{ due == 1 ? ' is' : 's are' }} coming up
       </div>
    </a>

</template>
